<template>
    <div>
        <div class="one_header">
            <div class="one_header_tit">
                <div class="tu">
                    <img src="~@/assets/images/opencard/open2.png" alt="" />
                </div>
                <div>证件合拍</div>
            </div>
        </div>
        <div class="three_con">
            <ul>
                <li>1.拍摄时，保持图片清晰，小卡板上的编码清晰可见。</li>
                <li>2.身份证反面与卡板不要遮挡，</li>
                <li>3.避免拍摄光线过亮，过暗。</li>
            </ul>
            <div class="ImgFor" v-if="TogetherImgsFlag == 'wu'">
                <img class="ImgData" src="@/assets/images/opencard/open7.png" @click="imgClick" />
            </div>
            <div class="ImgFor" v-if="TogetherImgsFlag == 'you'">
                <img class="ImgData" v-if="TogetherImgsFlag == 'you'" :src="TogetherImgsData" />
            </div>

            <input style="float: left; display: none" type="file" id="uploadFile" accept="image/*" capture="camera"
                @change="readLocalFile($event)" />
        </div>

    </div>
</template>

<script>
import Compressor from 'compressorjs';
export default {
    components: {},
    data() {
        return {
            // 是否增加小卡版数据
            TogetherImgsFlag: "wu", //用户合拍显示隐藏
            TogetherImgsData: "", //合拍base64码
        }
    },

    created() { },
    // 组件方法
    methods: {
        // 拍照
        imgClick() {
            document.getElementById("uploadFile").click()
        },

        // 获取拍的照片的数据
        async readLocalFile(e) {
            var localFile = document.getElementById("uploadFile").files[0]
            // 判断图片是否要压缩
            let isLt1M = localFile.size / 1024 / 1024 <= 1.5
            if (!isLt1M) {
                // this.ImgCompress(e, localFile, imgSize)
                var current = this
                new Compressor(localFile, {
                    quality: 0.8,
                    maxWidth: 1680,
                    maxHeight: 1260,
                    success(result) {
                        var reader = new FileReader()
                        var content

                        reader.onload = async function (event) {
                            content = event.target.result
                            current.$emit('ImgsBase64Data', content);
                            current.TogetherImgsData = content //获取图片base64代码
                            current.TogetherImgsFlag = "you"
                        }
                        reader.onerror = function (event) {
                            alert("error")
                        }
                        content = reader.readAsDataURL(result, "UTF-8")
                        let sss = document.getElementById("uploadFile").value
                    },
                    error(err) {
                        console.error('压缩失败:', err)
                    },
                })
            } else {
                // 拍的照片进行展示
                var reader = new FileReader()
                var content
                var current = this
                reader.onload = async function (event) {
                    content = event.target.result
                    current.$emit('ImgsBase64Data', content);
                    current.TogetherImgsData = content //获取图片base64代码
                    current.TogetherImgsFlag = "you"
                }
                reader.onerror = function (event) {
                    alert("error")
                }
                content = reader.readAsDataURL(localFile, "UTF-8")
                let sss = document.getElementById("uploadFile").value
            }
        },

        // // 图片压缩
        // ImgCompress(e, file, imgSize) {
        //     var vm = this
        //     vm.fileName = file.name
        //     let reader = new FileReader()
        //     reader.readAsDataURL(file)
        //     reader.onload = function (e) {
        //         let image = new Image() //新建一个img标签（还没嵌入DOM节点)
        //         image.src = e.target.result
        //         image.onload = function () {
        //             let imgWidth
        //             let imgHeight
        //             if (imgSize > 1 && imgSize <= 5) {
        //                 imgWidth = image.width / 2
        //                 imgHeight = image.height / 2
        //             } else if (imgSize > 5) {
        //                 imgWidth = image.width / 3
        //                 imgHeight = image.height / 3
        //             }
        //             let canvas = document.createElement("canvas"),
        //                 context = canvas.getContext("2d"),
        //                 imageWidth = imgWidth, //压缩后图片的大小
        //                 imageHeight = imgHeight,
        //                 data = ""
        //             canvas.width = imageWidth
        //             canvas.height = imageHeight
        //             console.log('压缩后的宽', canvas.width)
        //             console.log('压缩后的高', canvas.height)


        //             context.drawImage(image, 0, 0, imageWidth, imageHeight)
        //             data = canvas.toDataURL("image/jpeg")

        //             const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        //             const color = vm.getAverageColor(imageData);

        //             var arr = data.split(","),
        //                 mime = arr[0].match(/:(.*?);/)[1],
        //                 bstr = atob(arr[1]),
        //                 n = bstr.length,
        //                 u8arr = new Uint8Array(n)
        //             while (n--) {
        //                 u8arr[n] = bstr.charCodeAt(n)
        //             }
        //             let filePress = new File([u8arr], vm.fileName, {
        //                 type: mime,
        //             })
        //             vm.fileData = filePress
        //             console.log('压缩后的大小 --- MB', vm.fileData.size / 1024 / 1024)
        //             console.log('压缩后的大小 --- KB', vm.fileData.size / 1024)
        //             // 拍的照片进行展示
        //             var reader = new FileReader()
        //             var content
        //             reader.onload = async function (event) {
        //                 content = event.target.result
        //                 vm.$emit('ImgsBase64Data', content);
        //                 vm.TogetherImgsData = content //获取图片base64代码
        //                 vm.TogetherImgsFlag = "you"
        //             }
        //             reader.onerror = function (event) {
        //                 alert("error")
        //             }
        //             content = reader.readAsDataURL(vm.fileData, "UTF-8")
        //             let sss = document.getElementById("uploadFile").value
        //         }
        //     }
        // },

        // 获取rgb色
        getAverageColor(imageData) {
            const data = imageData.data;
            const r = this.getSum(data, 0);
            const g = this.getSum(data, 1);
            const b = this.getSum(data, 2);
            const count = data.length / 4;
            return `rgb(${Math.round(r / count)}, ${Math.round(g / count)}, ${Math.round(b / count)})`;
        },
        getSum(data, offset) {
            let sum = 0;
            for (let i = offset; i < data.length; i += 4) {
                sum += data[i];
            }
            return sum;
        },

    },

    computed: {},

    watch: {},

    mounted() { },
}
</script>

<style scoped lang='scss'>
.five {
    width: 100%;
    height: 60%;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;

    .one_header {
        width: 100%;
        height: 10%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: px2rem(20) px2rem(20);

        .one_header_tit {
            width: 30%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: px2rem(34);
            color: #a9a9a9;

            .tu {
                width: px2rem(50);
                height: px2rem(50);

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            span {
                font-size: px2rem(34);
            }
        }

        .stepNumber {
            color: #666668;
            font-size: px2rem(34);
        }
    }

    .three_con {
        width: 100%;
        height: 40%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        ul {
            width: 90%;
            height: 20%;
            // height: px2rem(100);
            border: 1px solid #ccc;
            font-size: px2rem(30);
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            color: red;
            padding: px2rem(10);

            li {
                width: 100%;
            }
        }


        .ImgFor {
            width: 90%;
            height: px2rem(800);

            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: self-end;


            .ImgData {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>